<span [portalTippy]="tooltip | translate" [tippyDisabled]="tooltipEnabled === false">
  <button
    #button
    [class]="buttonClass"
    [disabled]="disabled || state"
    [type]="buttonType"
    (click)="click()"
    data-style="expand-right"
  >
    @if (defaultSpinner) {
      <ng-container [ngTemplateOutlet]="spinner"></ng-container>
    }

    <span class="ms-1 content">
      <ng-content></ng-content>
    </span>
    <span class="default-content">
      <span class="ms-1">{{ 'button.save' | portalTranslate }}</span>
    </span>
  </button>
</span>

<ng-template #spinner>
  @if (state) {
    <i class="far fa-fw fa-circle-notch fa-spin"></i>
  } @else {
    <i class="far fa-fw fa-check"></i>
  }

  <!-- We use a template because now we can use the else of the *ngIf directive and check just once for state -->
</ng-template>
